import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all asset financial records
export const getAssetFinancial = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-financial`);
    return response.data;
  } catch (error) {
    console.error("Error fetching asset-financial:", error.response?.data || error);
    throw error;
  }
};

// GET a single asset financial record
export const getAssetFinancialById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/asset-financial/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching asset-financial:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new asset financial record
export const createAssetFinancial = async (assetFinancialData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/asset-financial`, assetFinancialData);
    return response.data;
  } catch (error) {
    console.error("Error creating asset-financial:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing asset financial record
export const updateAssetFinancial = async (id, assetFinancialData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/asset-financial/${id}`, assetFinancialData);
    return response.data;
  } catch (error) {
    console.error("Error updating asset-financial:", error.response?.data || error);
    throw error;
  }
};

// DELETE an asset financial record
export const deleteAssetFinancial = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/asset-financial/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting asset-financial:", error.response?.data || error);
    throw error;
  }
};
